import { LegalPage, LegalSection } from "@/components/LegalPage";

export default function TermsOfUse() {
  return (
    <LegalPage title="Termos de Uso" updated="outubro de 2026" testId="terms-page">
      <LegalSection title="1. Objeto">
        <p>
          Estes Termos de Uso regulam o acesso e a utilização do site da RESOLV (CNPJ
          69.470.510/0001-29), plataforma de tecnologia e serviços para gestão, organização e
          acompanhamento de demandas imobiliárias.
        </p>
      </LegalSection>

      <LegalSection title="2. Solicitações pelo site">
        <p>
          Ao enviar um formulário, você declara que as informações fornecidas são verdadeiras e
          autoriza a Resolv a entrar em contato pelos canais informados para tratar da sua
          solicitação. O envio de um formulário não gera obrigação de contratação por nenhuma
          das partes.
        </p>
      </LegalSection>

      <LegalSection title="3. Orçamentos e aprovações">
        <p>
          Nenhum serviço é executado sem orçamento apresentado e aprovação expressa do cliente
          ou do responsável pelo imóvel. Os valores, prazos e condições são definidos em cada
          demanda de forma transparente.
        </p>
      </LegalSection>

      <LegalSection title="4. Rede de prestadores parceiros">
        <p>
          Os serviços são executados por profissionais parceiros cadastrados na rede Resolv,
          selecionados conforme especialidade e região. A Resolv organiza, aciona e acompanha a
          execução de cada demanda do início ao fim.
        </p>
      </LegalSection>

      <LegalSection title="5. Responsabilidades">
        <p>
          A Resolv se compromete a conduzir as demandas com agilidade e transparência. O cliente
          se compromete a fornecer informações corretas e acesso ao imóvel quando necessário à
          execução dos serviços aprovados.
        </p>
      </LegalSection>

      <LegalSection title="6. Propriedade intelectual">
        <p>
          Todo o conteúdo deste site — incluindo marca, logotipo, textos e elementos visuais — é
          de propriedade da Resolv e não pode ser reproduzido sem autorização prévia.
        </p>
      </LegalSection>

      <LegalSection title="7. Privacidade">
        <p>
          O tratamento de dados pessoais segue a nossa{" "}
          <a href="/privacidade" className="font-semibold text-brand hover:underline">
            Política de Privacidade
          </a>
          , em conformidade com a LGPD (Lei nº 13.709/2018).
        </p>
      </LegalSection>

      <LegalSection title="8. Alterações e foro">
        <p>
          Estes termos podem ser atualizados a qualquer momento, com a versão vigente sempre
          disponível nesta página. Fica eleito o foro da comarca de São José/SC para dirimir
          eventuais controvérsias.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
